import { SxProps, Theme } from '@mui/material';
import { Colors } from '../../constants';

export const autocompleteOptionStyle: SxProps<Theme> = {
	display: 'inline-flex !important',
	width: 'fit-content',
	borderRadius: '100px',
	gap: '8px',
	border: `1px solid ${Colors.white_a20}`,

	ml: '16px',
	mb: '10px',
};

export const masteryLevelContainerStyle: SxProps<Theme> = {
	background: Colors.black_a40,
	backdropFilter: 'blur(16px)',
	borderRadius: '8px',
	minHeight: '100px',
	display: 'flex',
	flexDirection: 'column',
	p: '12px 16px',
	gap: '10px',
};

export const masteryLevelContainerHeader: SxProps<Theme> = {
	display: 'flex',
	alignItems: 'center',
	gap: '10px',
};

export const masteryLevelSelectedActivityStyle: SxProps<Theme> = {
	border: `1px solid ${Colors.white_a20}`,
	borderRadius: '100px',
	display: 'flex',
	alignItems: 'center',
	gap: '8px',
	p: '4px 12px',
};

export const masteryLevelSelectedActivityLabelStyle: SxProps<Theme> = {
	color: Colors.white,
	fontFamily: 'Montserrat, sans-serif',
	fontSize: '14px',
	fontWeight: 500,
	lineHeight: 1.5,
};

export const masteryLevelSelectLabel: SxProps<Theme> = {
	color: Colors.white,
	fontFamily: 'Montserrat, sans-serif',
	fontSize: '12px',
	fontWeight: 700,
};

export const masteryLevelButtonsContainer: SxProps<Theme> = {
	display: 'flex',
	alignItems: 'center',
	flexWrap: 'wrap',
	gap: '10px',
};

export const masteryLevelButton: SxProps<Theme> = {
	cursor: 'pointer',
	display: 'flex',
	alignItems: 'center',
	gap: '10px',
	border: `1px solid ${Colors.white_a20}`,
	borderRadius: '100px',
	p: '6px 12px',
};

export const masteryLevelIconWrapper: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column-reverse',
	gap: '4px',
	flexShrink: 0,
	minWidth: '16.5px',
};

export const masteryLevelIconLine = (active: boolean): SxProps<Theme> => ({
	borderRadius: '0.75px',
	height: '1.5px',
	alignSelf: 'stretch',
	backgroundColor: active ? Colors.white : Colors.white_a30,
});

export const masteryLevelLabel: SxProps<Theme> = {
	color: Colors.white,
	fontFamily: 'Montserrat, sans-serif',
	fontSize: '14px',
	fontWeight: 500,
	lineHeight: 1.5,
};

export const tagLabelBox: SxProps<Theme> = {
	display: 'flex',
	alignItems: 'center',
};

export const tagLabel: SxProps<Theme> = {
	color: Colors.white,
	fontFamily: 'Montserrat, sans-serif',
	fontSize: '14px',
	fontWeight: 500,
	lineHeight: 1.5,
};

export const tagMasteryLevelLabel: SxProps<Theme> = {
	color: Colors.white,
	fontFamily: 'Montserrat, sans-serif',
	fontSize: '14px',
	fontWeight: 500,
	lineHeight: 1.5,
};
